const glossaryEnglish = {
  title: 'Glossary',
  titleText1: 'Project',
  text1: 'The program prepared for achieving goals and objectives of the plan.',
  titleText2: 'Infrastructure Project',
  text2:
    'The plan or program developed for physical/infrastructure construction. ',
  titleText3: 'Running Project',
  text3:
    'A plan or activity that is being implemented to accomplish certain goals and objectives in a specified place.',
  titleText4: 'Contractor',
  text4:
    'Legal person that is competent to carry out works such as site preparation, excavation, erection, building, installation of equipment or goods and decoration etc, associated with the construction, reconstruction, demolition, repair or renovation of any structure or works, mapping, laboratory testing, satellite photography and seismic investigation.',
  titleText5: 'Consumer/User Committee',
  text5:
    'The committee formed by the persons directly benefited from construction works from amongst themselves so as to build, operate, repair and maintain such works. The laws related to public procurement has provided that construction work or service incidental thereto, the cost estimate of which does not exceed Ten million rupees may be done through or obtained from a user committee or beneficiary community .',
  titleText6: 'Projects undertaken by Contractors',
  text6:
    'The project carried out by contractors after concluding an agreement with the procuring body that publishes tenders in order to accomplish projects through competitive selection.  ',
  titleText7: 'Projects undertaken by Consumer/User Committee',
  text7:
    'A project operated by constituing a committee among the group of local beneficiaries.',
  titleText8: 'Tender',
  text8:
    'An advertisement called upon by a public entity with an intention to select appropriate persons/institution for procuring any construction work, goods or services/ Any cost estimate, proposal or unit rate submitted by bidders upon the procuring notice published by public entity. ',
  titleText9: 'Bidder',
  text9:
    'Any person, firm, organization or company competent enough to sumbit a bid to take part in the procurement procedures.',
  titleText10: 'Physical progress',
  text10: 'The achievement in accordance with to plan, project and program.',
  titleText11: 'Financial progress',
  text11:
    'A status of indicated income and expeenditure that is achieved in the financial transaction of a plan/project.',
  titleText12: 'Budget',
  text12:
    'Budget is an amount allocated by the local government to carry out a project with due process of law.',
  titleText13: 'Agreement/Contract',
  text13:
    'A consent in writing concluded between public entity and bidder for conducting a work. '
};

const glossaryNepali = {
  title: 'शब्दावली',
  titleText1: 'परियाेजना',
  text1:
    'योजनाको निश्चित लक्ष्य तथा उद्देश्य प्राप्ति गर्न तयार गरिएको कार्यक्रम।',
  titleText2: 'पूर्वाधार परियाेजना',
  text2: 'भौतिक विकास निर्माणका लागि तयार गरिएको योजना, कार्यक्रम।',
  titleText3: 'सञ्चालित परियाेजना',
  text3:
    'कुनै स्थान विशेष अनुसार निश्चित उदेश्य र लक्ष्य प्राप्तिका लागि संचालन भईरहेको योजना तथा कार्यक्रम।',
  titleText4: 'निर्माण व्यवसायी',
  text4:
    'कुनै संरचना वा कुनै कुराको निर्माण गर्ने, पुनः निर्माण गर्ने, भत्काउने, मर्मत सम्भार गर्ने वा जिर्णोद्धार गर्ने कार्यसँग सम्बन्धित निर्माण स्थल तयार गर्ने, खन्ने, ठड्याउने, बनाउने, उपकरण वा मालसामान जडान गर्ने, सजाउने, नक्शा बनाउने, प्रयोगशाला परीक्षण गर्ने, भूउपग्रहीय फोटो खिच्ने, भूकम्पीय परीक्षण गर्ने जस्ता निर्माण कार्य गर्ने कानुनी हैसियत प्राप्त कम्पनी । ',
  titleText5: 'उपभाेक्ता समिति',
  text5:
    'निर्माण कार्यबाट प्रत्यक्ष लाभ पाउने व्यक्तिहरुले कुनै निर्माण कार्यको निर्माण, सञ्चालन, मर्मत सम्भार गर्नको लागि आफूहरुमध्येबाट गठन गरेको समिति। नेपालकाे सार्वजनिक खरिद एेन/नियमले एक करोड रुपैंयाँसम्म लागत अनुमान भएको निर्माण कार्य वा सो सम्बन्धी सेवा उपभोक्ता समिति वा लाभग्राही समुदायबाट काम गराउन सकिने गरी कानुनी व्यवस्था गरेकाे छ ।',
  titleText6: 'निर्माण व्यवसायीबाट सञ्चालित परियाेजना',
  text6:
    'योजनाको उदेश्य प्राप्तिको लागि सार्वजनिक निकायबाट प्रकाशित टेण्डरअनुरुप प्रतिस्पर्धामार्फत सार्वजनिक निकायसंग सम्झौता निर्माण व्यवसायीबाट संचालित परियोजना।',
  titleText7: 'उपभाेक्ता समितिबाट सञ्चालित परियाेजना',
  text7:
    'स्थानीय स्तरको लाभान्वित समुहबाट समिति गठन गरी संचालन गरिएको परियोजना।',
  titleText8: 'टेण्डर',
  text8:
    'सार्वजनिक निकायले कुनै पनि निर्माण कार्य, बस्तु खरिद वा परामर्श खरिदका सम्बन्धमा प्रतिस्पर्धामार्फत उपयुक्त व्यक्ति वा संस्थाकाे चयन गर्ने प्रकृयाअनुरुप आह्वान गर्ने विज्ञापन / सार्वजनिक निकायले खरिदका लागि प्रकाशन गरेको सूचना अनुरुप सो निकायले तोकेको ढांचामा बोलपत्रदाताले पेश गरेको मुल्य खुल्ने कागजात, प्रस्ताव वा दररेट।',
  titleText9: 'बाेलपत्रदाता',
  text9:
    'खरिद कारबाहीमा भाग लिन बोलपत्र पेश गर्ने वा गर्न सक्ने कुनै व्यक्ति,फर्म, संस्था वा कम्पनी । ',
  titleText10: 'भाैतिक प्रगति',
  text10: 'योजना, परियोजना तथा कार्यक्रमको तोकिएको लक्ष्य अनुसारको प्राप्ति।',
  titleText11: 'वित्तिय प्रगति ',
  text11:
    'योजना, परियोजनाको आर्थिक कारोबारमा तोकिएको आम्दानी तथा खर्चको प्राप्ति।',
  titleText12: 'बजेट',
  text12:
    'बजेट भन्नाले परियाेजना  सम्पन्न गर्नका  लागि स्थानिय सरकारले विधि प्रकृया पुर्याइ विनियाेजन गरेकाे रकम हाे ।',
  titleText13: 'करार/सम्झौता',
  text13:
    'सार्वजनिक निकाय र बाेलपत्रदाताबीच कुनै पनि कार्य गर्नेसम्बन्धमा भएकाे लिखित मञ्जुरी । '
};

export { glossaryEnglish, glossaryNepali };



// WEBPACK FOOTER //
// ./src/localization/glossary.js